import { render, staticRenderFns } from "./Attend.vue?vue&type=template&id=8da5228e&scoped=true&"
import script from "./Attend.vue?vue&type=script&lang=js&"
export * from "./Attend.vue?vue&type=script&lang=js&"
import style0 from "./Attend.vue?vue&type=style&index=0&id=8da5228e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da5228e",
  null
  
)

export default component.exports